/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Réglage des primes dérivées (Cat Nat, Cat Tech, Attentat) d'une branche. Les taux sont des pourcentages de l'assiette (20 = 20 %).
 * @export
 * @interface UpdatePrimesDeriveesBrancheCommand
 */
export interface UpdatePrimesDeriveesBrancheCommand {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePrimesDeriveesBrancheCommand
     */
    derivedPremiumsEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdatePrimesDeriveesBrancheCommand
     */
    catNatRate?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePrimesDeriveesBrancheCommand
     */
    catTechRate?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePrimesDeriveesBrancheCommand
     */
    attackRate?: number;
}

/**
 * Check if a given object implements the UpdatePrimesDeriveesBrancheCommand interface.
 */
export function instanceOfUpdatePrimesDeriveesBrancheCommand(value: object): value is UpdatePrimesDeriveesBrancheCommand {
    if (!('derivedPremiumsEnabled' in value) || value['derivedPremiumsEnabled'] === undefined) return false;
    return true;
}

export function UpdatePrimesDeriveesBrancheCommandFromJSON(json: any): UpdatePrimesDeriveesBrancheCommand {
    return UpdatePrimesDeriveesBrancheCommandFromJSONTyped(json, false);
}

export function UpdatePrimesDeriveesBrancheCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePrimesDeriveesBrancheCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'derivedPremiumsEnabled': json['derivedPremiumsEnabled'],
        'catNatRate': json['catNatRate'] == null ? undefined : json['catNatRate'],
        'catTechRate': json['catTechRate'] == null ? undefined : json['catTechRate'],
        'attackRate': json['attackRate'] == null ? undefined : json['attackRate'],
    };
}

export function UpdatePrimesDeriveesBrancheCommandToJSON(json: any): UpdatePrimesDeriveesBrancheCommand {
    return UpdatePrimesDeriveesBrancheCommandToJSONTyped(json, false);
}

export function UpdatePrimesDeriveesBrancheCommandToJSONTyped(value?: UpdatePrimesDeriveesBrancheCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'derivedPremiumsEnabled': value['derivedPremiumsEnabled'],
        'catNatRate': value['catNatRate'],
        'catTechRate': value['catTechRate'],
        'attackRate': value['attackRate'],
    };
}

